import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import login from '@/components/login'
import fbeePay from '@/components/fbeePay'
import waitPay from '@/components/waitPay'
import asstsQuery from '@/components/asstsQuery'
import userInfo from '@/components/userInfo'
import asstsHistroy from '@/components/asstsHistroy'
import share from '@/components/share'
import fbeePayHistrony from '@/components/fbeePayHistrony'
import fbeePayHistronyById from '@/components/fbeePayHistronyById'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/fbeePay',
      name: 'fbeePay',
      component: fbeePay
    },
    {
      path: '/waitPay',
      name: 'waitPay',
      component: waitPay
    },
    {
      path: '/asstsQuery',
      name: 'asstsQuery',
      component: asstsQuery
    },
    {
      path: '/userInfo',
      name: 'userInfo',
      component: userInfo
    },
    {
      path: '/asstsHistroy',
      name: 'asstsHistroy',
      component: asstsHistroy
    },
    {
      path: '/share',
      name: 'share',
      component: share
    },
    {
      path: '/fbeePayHistrony',
      name: 'fbeePayHistrony',
      component: fbeePayHistrony
    },
    {
      path: '/fbeePayHistronyById',
      name: 'fbeePayHistronyById',
      component: fbeePayHistronyById
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js